import React from 'react';
import { Col } from 'reactstrap';
import totalReadingIcon from '../../assets/img/notes/notes_icon2.svg';
import totalNotesIcon from '../../assets/img/notes/notes_icon3.svg';
import totalFreeQuestionIcon from '../../assets/img/question_bank/free_question_icon.svg';
import totalPremiumQuestionIcon from '../../assets/img/question_bank/premium_question_icon.svg';
import language from '../../assets/languages/language';
import config from '../../views/config/App_data';
import CardImageAndCount from './CardImageAndCount';
function ChapterCard(props) {
  const {
    headerImage,
    chapterOrder,
    chapterNumber,
    chapterName,
    totalReadings,
    headerImageWidth,
    totalNotes,
    premiumQuestionsCount,
    freeQuestionsCount,
    // showFreePremiumTag = true,
    callingComponent,
    children,
    onClick,
    userSubscriptionDetails= false,
    free,
  } = props;
  return (
    <Col
      xs='12'
      sm={6}
      lg={6}
      xl={4}
      className='question_box free-premium-section'
      key={chapterNumber}
    >
      <div className='question_bank_wrap pointer_class' key={chapterNumber} onClick={onClick}>
        {!userSubscriptionDetails && callingComponent === 'notes' ? (
          free ? (
            <div className='tag-tile free'> {language.LC().FREE} </div>
          ) : (
            <div className='tag-tile premium'> {language.LC().PREMIUM} </div>
          )
        ) : null}
        <div className='margin_bottom_30'>
          <img
            src={headerImage}
            className=''
            width={headerImageWidth || 40}
            alt=''
          />
        </div>
        <div className='question_title' key={chapterNumber} value={chapterNumber}>
          <a>
            {chapterOrder || chapterNumber}. {chapterName}
          </a>
        </div>
        <ul key={chapterName}>
          {/* ============== Total Readings ============== */}
          {totalReadings && (
            <CardImageAndCount
              imageURL={totalReadingIcon}
              count={totalReadings}
              text={language.LC().TOTAL_READINGS}
              width='24'
            />
          )}

          {/* ============== Total Notes ============== */}
          {totalNotes && (
            <CardImageAndCount
              imageURL={totalNotesIcon}
              count={totalNotes}
              text={language.LC().TOTAL_NOTES}
              width='20'
            />
          )}

          {/* ============== Free Questions Count============== */}
          {freeQuestionsCount !== 'undefined' && callingComponent !== 'notes' && (
            <CardImageAndCount
              imageURL={totalFreeQuestionIcon}
              count={freeQuestionsCount}
              text={language.LC().FREE_QUESTIONS}
              width='26'
            />
          )}

          {/* ============== Premium Questions Count============== */}
          {premiumQuestionsCount && callingComponent !== 'notes' && (
            <CardImageAndCount
              imageURL={totalPremiumQuestionIcon}
              count={premiumQuestionsCount}
              text={language.LC().PREMIUM_QUESTIONS}
              width='23'
            />
          )}

          {/* ============== Ready for Print ============== */}
          {/* {callingComponent === 'notes' && (
            <CardImageAndCount
              imageURL={printIcon}
              count={language.LC().VIEW}
              text={language.LC().VIEW_PDF}
              width='23'
            />
          )} */}

          {children}
        </ul>
      </div>
    </Col>
  );
}

export default ChapterCard;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/ChapterCards.jsx